import { Resource } from './resource';
import { gql } from 'apollo-boost';

export class TimetableResource extends Resource {
  public static async get() {
    return await this.query({
      query: gql`
        query {
          timetables {
            id
            name
            monday
            tuesday
            wednesday
            thursday
            friday
            saturday
            sunday
            monTime
            tueTime
            wedTime
            thuTime
            friTime
            satTime
            sunTime
          }
        }
      `
    });
  }

  public static async delete(id: number) {
    return await this.mutation({
      mutation: gql`
        mutation($id: Int!) {
          timetableDelete(id: $id) {
            id
          }
        }
      `,
      variables: { id }
    });
  }

  public static async create(name: string, workTime: any, startTime: object) {
    return this.mutation({
      mutation: gql`
        mutation(
          $name: String!
          $monday: Int
          $tuesday: Int
          $wednesday: Int
          $thursday: Int
          $friday: Int
          $saturday: Int
          $sunday: Int
          $monTime: Int
          $tueTime: Int
          $wedTime: Int
          $thuTime: Int
          $friTime: Int
          $satTime: Int
          $sunTime: Int
        ) {
          timetableCreate(
            timetableInput: {
              name: $name
              monday: $monday
              tuesday: $tuesday
              wednesday: $wednesday
              thursday: $thursday
              friday: $friday
              saturday: $saturday
              sunday: $sunday
              monTime: $monTime
              tueTime: $tueTime
              wedTime: $wedTime
              thuTime: $thuTime
              friTime: $friTime
              satTime: $satTime
              sunTime: $sunTime
            }
          ) {
            id
            name
            monday
            tuesday
            wednesday
            thursday
            friday
            saturday
            sunday
            monTime
            tueTime
            wedTime
            thuTime
            friTime
            satTime
            sunTime
          }
        }
      `,
      variables: {
        name,
        monTime: workTime.monday,
        tueTime: workTime.tuesday,
        wedTime: workTime.wednesday,
        thuTime: workTime.thursday,
        friTime: workTime.friday,
        satTime: workTime.saturday,
        sunTime: workTime.sunday,
        ...startTime
      }
    });
  }

  public static async update(id: number, name: string, workTime: any, startTime: object) {
    return this.mutation({
      mutation: gql`
        mutation(
          $id: Int!
          $name: String!
          $monday: Int
          $tuesday: Int
          $wednesday: Int
          $thursday: Int
          $friday: Int
          $saturday: Int
          $sunday: Int
          $monTime: Int
          $tueTime: Int
          $wedTime: Int
          $thuTime: Int
          $friTime: Int
          $satTime: Int
          $sunTime: Int
        ) {
          timetableUpdate(
            id: $id
            timetableInput: {
              name: $name
              monday: $monday
              tuesday: $tuesday
              wednesday: $wednesday
              thursday: $thursday
              friday: $friday
              saturday: $saturday
              sunday: $sunday
              monTime: $monTime
              tueTime: $tueTime
              wedTime: $wedTime
              thuTime: $thuTime
              friTime: $friTime
              satTime: $satTime
              sunTime: $sunTime
            }
          ) {
            name
            monday
            tuesday
            wednesday
            thursday
            friday
            saturday
            sunday
            monTime
            tueTime
            wedTime
            thuTime
            friTime
            satTime
            sunTime
          }
        }
      `,
      variables: {
        id,
        name,
        monTime: workTime.monday,
        tueTime: workTime.tuesday,
        wedTime: workTime.wednesday,
        thuTime: workTime.thursday,
        friTime: workTime.friday,
        satTime: workTime.saturday,
        sunTime: workTime.sunday,
        ...startTime
      }
    });
  }

  public static async getBasic() {
    return await this.query({
      query: gql`
        query {
          timetables {
            id
            name
          }
        }
      `
    });
  }

  public static async setTimetableToEmployee(userId: number, timetableId: number, model: any) {
    return await this.mutation({
      mutation: gql`
        mutation($userId: Int!, $timetableId: Int!, $startDate: String!, $endDate: String) {
          employeeTimetableSet(userId: $userId, timetableId: $timetableId, startDate: $startDate, endDate: $endDate) {
            id
            timetable {
              name
            }
            startDate
            endDate
          }
        }
      `,
      variables: {
        userId,
        timetableId,
        startDate: model.startDate,
        endDate: model.endDate
      }
    });
  }

  public static async employeeTimetableRemove(id: number) {
    return await this.mutation({
      mutation: gql`
        mutation($id: Int!) {
          employeeTimetableRemove(id: $id) {
            status
          }
        }
      `,
      variables: { id }
    });
  }
}
